import {PureComponent} from 'react';
import {Switch, Redirect} from 'react-router-dom';

import {ROUTE_PATH} from 'constants/routes';
import {UnauthorizedLayout} from 'layouts';
import {AuthRoute} from 'utils/routes';

import {TestKurentoVideo} from './KurentoVideo';
import {TestTwilioVideo} from './TwilioVideo';

export default class Test extends PureComponent {

    render() {
        return (
            <UnauthorizedLayout hasTranslate={false}>
                <Switch>
                    <AuthRoute path={ROUTE_PATH.TEST.TWILIO_VIDEO} component={TestTwilioVideo} />
                    <AuthRoute path={ROUTE_PATH.TEST.KURENTO_VIDEO} component={TestKurentoVideo} />
                    <Redirect to={ROUTE_PATH.TEST.TWILIO_VIDEO} />
                </Switch>
            </UnauthorizedLayout>
        );
    }
}
